<template>
  <div
    class="fallback-model-page fallback-model-page--edit-or-create fallback-model-page--create"
  >
    <ModelCreatePage
      ref="ModelPage"
      v-bind="modelCreatePageProps"
      :modelName="modelName"
      :virtualModelName="virtualModelName"
      :key="hookName"
    />
  </div>
</template>

<script lang="ts">
import { checkModelFormHasChanged } from './checkModelFormHasChanged'

export default {
  name: 'FallbackModelNewPage',
  props: {
    modelCreatePageProps: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    modelName() {
      return this.$route.params.fallback_model
    },
    virtualModelName() {
      return this.$route.query.virtualModel
    },
    hookName() {
      return `$CORE.admin.resolveComponent.model.${
        this.virtualModelName || this.modelName
      }.pages.new`
    },
  },
  async beforeRouteLeave(to, from, next) {
    checkModelFormHasChanged(this, next)
  },
}
</script>
